import { Injectable } from '@angular/core';
import { EnvService } from '@core-mkt/services/env/env.service';

import type { VerticalInfo } from './vertical';

@Injectable({
  providedIn: 'root',
})
export class VerticalService {
  constructor(private env: EnvService) {}
  getVerticalInfo(): VerticalInfo {
    return {
      vertical: this.env.get.brandConfig.vertical,
      segmentId: this.env.get.segmentId,
      brandId: this.env.get.brandConfig.iterable?.brandId,
      appType: this.env.get.brandConfig.iterable?.appType,
    };
  }
}
